<template>
  <div
    class="absolute right-0 mt-2 w-48 bg-white border border-skin-b-list-bord rounded shadow-lg"
  >
    <ul class="divide-y divide-gray-200">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="px-4 py-2 cursor-pointer"
        :class="{
              'hover:text-skin-b-base hover:bg-skin-b-back' : item.color==undefined,
              'text-red-800 bg-red-100 sm:text-skin-b-base sm:bg-skin-b-list-back sm:hover:text-red-800 sm:hover:bg-red-100' : item.color=='red',
              'text-green-800 bg-green-100 sm:text-skin-b-base sm:bg-skin-b-list-back sm:hover:text-green-800 sm:hover:bg-green-100' : item.color=='green',
              }"
        @click="item.onClick"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['close'],
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.$emit('close');
      }
    },
  },
};
</script>
